import { WhiteContainer, CustomText, Flex, CustomButton } from '../../common';
import { AddEditSchoolContainer, AddEditSchoolContent } from './Schools.style';
import { RouteInfo } from '../../components/RouteInfo/RouteInfo';
import { Autocomplete, Divider, MenuItem, useTheme } from '@mui/material';
import { useForm } from '../../hooks/useForm';
import { SelectField, InputField, PhoneNumberInput, ColorPicker } from '../../components/Inputs';
import { SmallCircle } from '../../components/RouteInfo/RouteInfo.style';
import { Wallet } from '../../svg/Wallet';
import { ROUTES } from '../../constants';
import { BackTitle } from '../../components/BackTitle';
import { useSchools } from '../../hooks/useSchools';
import { SchoolAddType } from '../../types';
import { ImageInput } from './ImageInput';
import { isEmpty } from '../../helpers';
import { useNotification } from '../../hooks/useNotification';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { useNavigate } from 'react-router-dom';
import { AutocompleteInput } from '../../components/Inputs/AutocompleteInput';
import { countries } from '../../constants/countries';
import { InputWrapper } from '../../components/Inputs/InputWrapper';
import { CustomInput } from '../../components/Inputs/Input';
export const AddSchool: React.FC<{}> = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { notifyError } = useNotification();
  const { mutationAdd } = useSchools();
  const typeOptions: string[] = ['university', 'primary', 'secondary'];
  const { values, onChange, forceChange, setValues } = useForm<SchoolAddType>({
    email: '',
    name: '',
    type: '',
    phoneNumber: '',
    founded: '',
    website: '',
    hexColor: '',
    address: '',
    image: {
      type: '',
      data: '',
    },
    bank: {
      name: '',
      country: '',
      accountNumber: '',
      ibanNumber: '',
      swiftCode: '',
    },
    squareData: {
      appId: '',
      locationId: '',
      accessToken: '',
    },
  });

  const handleSubmit = () => {
    if (
      isEmpty(values) ||
      isEmpty(values.squareData) ||
      isEmpty(values.bank) ||
      (values?.image && isEmpty(values?.image))
    ) {
      notifyError('Please fill in all fields');
      return;
    } else if (values.phoneNumber.length < 10) {
      notifyError('Please provide valid phone number');
      return;
    }
    mutationAdd.mutate(values);
  };

  return (
    <>
      <RouteInfo />
      <AddEditSchoolContainer>
        <Flex noFlex>
          <BackTitle title={'Add School'} onClick={() => navigate(ROUTES.SCHOOLS)} />
        </Flex>
        <WhiteContainer padding="0px">
          <AddEditSchoolContent>
            <Flex column p={20} fullHeight>
              <Flex flex={2} column fullHeight>
                <Flex noCenter>
                  <ImageInput
                    handleChange={(data: string) => forceChange(data, 'image')}
                    hexColor={values.hexColor}
                  />
                  <Flex flexEnd column fullHeight>
                    <InputField
                      type="text"
                      name="email"
                      info="Email"
                      padding="4px 20px"
                      placeholder="Email"
                      onChange={(e: any) => onChange(e)}
                      value={values.email}
                    />

                    <Flex>
                      <PhoneNumberInput
                        type="text"
                        name="phoneNumber"
                        info="Phone"
                        padding="4px 20px"
                        placeholder="Enter here..."
                        onChange={(value: string) => forceChange(value, 'phoneNumber')}
                        value={values.phoneNumber}
                      />
                      <InputField
                        type="number"
                        name="founded"
                        info="Founded"
                        padding="4px 20px"
                        placeholder="Enter here..."
                        onChange={(e: any) => onChange(e)}
                        value={values.founded}
                      />
                    </Flex>
                    <InputField
                      type="text"
                      name="website"
                      info="Website"
                      padding="4px 20px"
                      placeholder="Enter here..."
                      onChange={(e: any) => onChange(e)}
                      value={values.website}
                    />
                  </Flex>
                </Flex>
              </Flex>
              <Flex>
                <Flex>
                  <InputField
                    type="text"
                    name="name"
                    info="Name"
                    padding="4px 20px"
                    placeholder="School Name"
                    onChange={(e: any) => onChange(e)}
                    value={values.name}
                  />
                </Flex>
                <Flex>
                  <Flex>
                    <InputField
                      type="text"
                      name="squareData.appId"
                      info="Square Aplication ID"
                      padding="4px 20px"
                      placeholder="Enter here..."
                      value={values.squareData.appId}
                      onChange={(e: any) =>
                        setValues((prev: any) => ({
                          ...prev,
                          squareData: {
                            ...prev.squareData,
                            appId: e.target.value,
                          },
                        }))
                      }
                    />
                  </Flex>
                </Flex>
              </Flex>
              <Flex>
                <Flex>
                  <Flex>
                    <SelectField
                      type="text"
                      name="type"
                      info="School Type"
                      padding="4px 20px"
                      placeholder="Select type"
                      onChange={(e: any) => onChange(e)}
                      value={values.type}
                    >
                      {typeOptions.map((type: string) => (
                        <MenuItem value={type}>{type.toLocaleUpperCase()}</MenuItem>
                      ))}
                    </SelectField>
                  </Flex>
                  <ColorPicker
                    type="text"
                    name="hexColor"
                    info="School Color"
                    padding="4px 20px"
                    placeholder="Pick Color"
                    onChange={(e: any) => forceChange(e.target.value, 'hexColor')}
                    value={values.hexColor}
                  />
                </Flex>
                <Flex>
                  <InputField
                    type="text"
                    name="locationId"
                    info="Sqare Location ID"
                    padding="4px 20px"
                    placeholder="Enter here..."
                    value={values.squareData.locationId}
                    onChange={(e: any) =>
                      setValues((prev: any) => ({
                        ...prev,
                        squareData: {
                          ...prev.squareData,
                          locationId: e.target.value,
                        },
                      }))
                    }
                  />
                </Flex>
              </Flex>
              <Flex>
                <Flex>
                  <Flex>
                    <InputField
                      type="text"
                      name="address"
                      info="Address"
                      padding="4px 20px"
                      placeholder="Enter here..."
                      onChange={(e: any) => onChange(e)}
                      value={values.address}
                    />
                  </Flex>
                </Flex>
                <Flex>
                  <InputField
                    type="text"
                    name="accessToken"
                    info="Access Token"
                    padding="4px 20px"
                    placeholder="Enter here..."
                    value={values.squareData.accessToken}
                    onChange={(e: any) =>
                      setValues((prev: any) => ({
                        ...prev,
                        squareData: {
                          ...prev.squareData,
                          accessToken: e.target.value,
                        },
                      }))
                    }
                  />
                </Flex>
              </Flex>
            </Flex>
            <Divider orientation="vertical" />
            <Flex column p={20} fullHeight>
              <Flex column flex={2} spaceBetween>
                <Flex gap={20}>
                  <SmallCircle size={80}>
                    <Wallet />
                  </SmallCircle>
                  <CustomText bold={700} color={theme.color.darkerBlue} fontSize={1.4}>
                    Payout Information
                  </CustomText>
                </Flex>
                <AutocompleteInput
                  name="bank.country"
                  info="Country"
                  autoHighlight
                  placeholder="Select"
                  value={values.bank.country}
                  options={countries}
                  onChange={(e: any, obj: any) => {
                    setValues((prev: any) => ({
                      ...prev,
                      bank: {
                        ...prev.bank,
                        country: obj.name,
                      },
                    }));
                  }}
                />
              </Flex>
              <Flex>
                <InputField
                  type="text"
                  name="bank.name"
                  info="Bank Name"
                  padding="4px 20px"
                  placeholder="Enter here..."
                  value={values.bank.name}
                  onChange={(e: any) =>
                    setValues((prev: any) => ({
                      ...prev,
                      bank: {
                        ...prev.bank,
                        name: e.target.value,
                      },
                    }))
                  }
                />
              </Flex>
              <Flex>
                <InputField
                  type="text"
                  name="bank.accountNumber"
                  info="Account Number"
                  padding="4px 20px"
                  placeholder="0000000000"
                  value={values.bank.accountNumber}
                  onChange={(e: any) =>
                    setValues((prev: any) => ({
                      ...prev,
                      bank: {
                        ...prev.bank,
                        accountNumber: e.target.value,
                      },
                    }))
                  }
                />
              </Flex>
              <Flex>
                <InputField
                  type="text"
                  name="bank.swiftCode"
                  info="Swift Code"
                  padding="4px 20px"
                  placeholder="0000000000"
                  value={values.bank.swiftCode}
                  onChange={(e: any) =>
                    setValues((prev: any) => ({
                      ...prev,
                      bank: {
                        ...prev.bank,
                        swiftCode: e.target.value,
                      },
                    }))
                  }
                />
                <InputField
                  type="text"
                  name="bank.ibanNumber"
                  info="IBAN Number"
                  padding="4px 20px"
                  placeholder="0000000000"
                  onChange={(e: any) =>
                    setValues((prev: any) => ({
                      ...prev,
                      bank: {
                        ...prev.bank,
                        ibanNumber: e.target.value,
                      },
                    }))
                  }
                  value={values.bank.ibanNumber}
                />
              </Flex>
            </Flex>
          </AddEditSchoolContent>
        </WhiteContainer>
        <Flex p="20px 0" noFlex>
          <Flex gap={30} flexEnd>
            <Flex noFlex>
              <CustomButton width="200px" bgcolor={theme.color.grey} onClick={() => navigate(-1)}>
                <CustomText>Cancel</CustomText>
              </CustomButton>
            </Flex>
            <Flex noFlex>
              <CustomButton width="200px" loading={mutationAdd.isLoading} onClick={handleSubmit}>
                <CustomText color="white">Save</CustomText>
              </CustomButton>
            </Flex>
          </Flex>
        </Flex>
      </AddEditSchoolContainer>
    </>
  );
};
